import { render, staticRenderFns } from "./ViewBillsWallet.vue?vue&type=template&id=6c2180f4&scoped=true&"
import script from "./ViewBillsWallet.vue?vue&type=script&lang=js&"
export * from "./ViewBillsWallet.vue?vue&type=script&lang=js&"
import style0 from "./ViewBillsWallet.vue?vue&type=style&index=0&id=6c2180f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2180f4",
  null
  
)

export default component.exports